'use client';

import { useProductIdStore } from '../model';
import { useEffect } from 'react';

type InitProductStoreIdProps = {
    id: string;
};

export const InitProductStoreId = ({ id }: InitProductStoreIdProps) => {
    const { setProductId, resetProductId } = useProductIdStore();

    useEffect(() => {
        // Set the productId when the component mounts or id changes
        setProductId(id);

        // Reset the productId when the component unmounts or id changes
        return () => {
            resetProductId();
        };
    }, [id, resetProductId, setProductId]);

    return null;
};
